module.exports = __webpack_public_path__ + "media/src/images/example_voucher_card_de-e694d37d9f27c6807814ae25d3aebce0.jpg";